exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table th[data-v-aed24c18],td[data-v-aed24c18]{font-size:14px}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/views/report_cancel_receive.vue"],"names":[],"mappings":"AACA,+CAEE,cAAgB,CACjB","file":"report_cancel_receive.vue","sourcesContent":["\n.table th[data-v-aed24c18],\r\ntd[data-v-aed24c18] {\r\n  font-size: 14px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aed24c18","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/report_cancel_receive.vue
// module id = 415
// module chunks = 24